import type { InternalServerError } from '@platform/core/errors';

import { ErrorServer } from '@packages/fenrir/feedback/errors/error-server';
import { PageContainerRoot } from '@packages/fenrir/page-blocks/page-container/page-container-root';
import { PagePlain } from '@packages/fenrir/pages/page-plain';

type InternalServerErrorPageProps = {
  error?: InternalServerError;
};

// TODO: S2CX-15999: Move hard coded text to translations when @platform/core/locale/i18n is enabled
export const InternalServerErrorPage = ({
  error,
}: InternalServerErrorPageProps) => {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <PagePlain>
      <PageContainerRoot>
        <ErrorServer
          reloadOnClick={refreshPage}
          actionLink={error?.data.actionProps}
        />
      </PageContainerRoot>
    </PagePlain>
  );
};
